import React, { Suspense, lazy } from "react";
import { LoadingState } from "../../components/UI/States";

// three.js is ~150 KB gzipped, so the /tools designers are their own chunks:
// only people who open one download it, not every page load.
const BuildingDesigner = lazy(() => import("./BuildingDesigner/BuildingDesigner"));
const DeckDesigner = lazy(() => import("./DeckDesigner/DeckDesigner"));

const loading = <LoadingState label="Loading the designer…" className="min-h-[60vh]" />;

export const LazyBuildingDesigner = () => (
  <Suspense fallback={loading}>
    <BuildingDesigner />
  </Suspense>
);

export const LazyDeckDesigner = () => (
  <Suspense fallback={loading}>
    <DeckDesigner />
  </Suspense>
);
